// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"3b0a2623","703":"cfaab64e","787":"abe8006e"}[chunkId] + ".chunk.js";
};